var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 3.66602C2.41283 3.66602 1.66699 4.41185 1.66699 5.33268V16.166C1.66699 16.626 2.04033 16.9993 2.50033 16.9993C2.96033 16.9993 3.33366 16.626 3.33366 16.166V5.33268H14.167C14.627 5.33268 15.0003 4.95935 15.0003 4.49935C15.0003 4.03935 14.627 3.66602 14.167 3.66602H3.33366ZM6.66699 6.99935C5.74616 6.99935 5.00033 7.74518 5.00033 8.66602V18.666C5.00033 19.5869 5.74616 20.3327 6.66699 20.3327H16.667C17.5878 20.3327 18.3337 19.5869 18.3337 18.666V8.66602C18.3337 7.74518 17.5878 6.99935 16.667 6.99935H6.66699ZM6.66699 8.66602H16.667V18.666H6.66699V8.66602Z",
    fill: "#9198A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.37acb6c517afc1badc4444a108f1ec35.svg";
export { ForwardRef as ReactComponent };